import { cn } from "@/lib/chillnn/cn";

import { TableHead, TableHeader, TableRow } from "@/components/ui/table/table";

type Props = { hasSortItem?: boolean; isSorting: boolean };

export const RoomListTableHeader = ({ hasSortItem, isSorting }: Props) => {
	return (
		<TableHeader>
			<TableRow className="hover:bg-white">
				<TableHead
					className={cn(
						"w-12", //
						(!hasSortItem || (hasSortItem && !isSorting)) && "hidden",
					)}
				/>
				<TableHead justifyStyle="center" className="w-72">
					部屋名
				</TableHead>
				<TableHead justifyStyle="center" className="w-24">
					ステータス
				</TableHead>
				<TableHead justifyStyle="center" className="w-28">
					定員
				</TableHead>
				<TableHead justifyStyle="center" className="w-20">
					総在庫
				</TableHead>
				<TableHead justifyStyle="center" className="w-28">
					販売タイプ
				</TableHead>
				<TableHead justifyStyle="center" className="w-48">
					操作
				</TableHead>
			</TableRow>
		</TableHeader>
	);
};

RoomListTableHeader.displayName = "RoomListTableHeader";
